var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7046 2.29183C10.4962 1.0835 8.83789 0.333496 6.99622 0.333496C3.31289 0.333496 0.337891 3.31683 0.337891 7.00016C0.337891 10.6835 3.31289 13.6668 6.99622 13.6668C10.1046 13.6668 12.6962 11.5418 13.4379 8.66683H11.7046C11.0212 10.6085 9.17123 12.0002 6.99622 12.0002C4.23789 12.0002 1.99622 9.7585 1.99622 7.00016C1.99622 4.24183 4.23789 2.00016 6.99622 2.00016C8.37956 2.00016 9.61289 2.57516 10.5129 3.4835L7.82956 6.16683H13.6629V0.333496L11.7046 2.29183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.a65b3b4f3c78eda15659cb3b0e872898.svg";
export { ForwardRef as ReactComponent };